import {Component, inject, OnInit} from '@angular/core';

import {AlertService} from "@numizmat/services/common";
import {EventApiService} from "@numizmat/services/core";
import {EventResponse} from "@numizmat/services-models/core";

@Component({
    selector: 'nz-events-section',
    imports: [],
    templateUrl: './events-section.component.html',
    styleUrl: './events-section.component.scss'
})
export class EventsSectionComponent implements OnInit {
  private alertService: AlertService = inject(AlertService);
  private eventApiService: EventApiService = inject(EventApiService);

  protected events: EventResponse[] = [];

  public ngOnInit(): void {
    this.getAllEvents();
  }

  protected showEventInfo(event: EventResponse): void {
    this.alertService.showEventInfo(event);
  }

  private getAllEvents(): void {
    this.eventApiService.getAllEvents().subscribe({
      next: response => {
        this.events = response;
      }
    });
  }
}
